import { Component, Inject, OnInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-mockup-preview',
  templateUrl: './mockup-preview.component.html',
  styleUrls: ['./mockup-preview.component.css']
})
export class MockupPreviewComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<MockupPreviewComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  closePreviewDialog(): void {
    this.dialogRef.close();
  }

}
